module.exports = __webpack_public_path__ + "media/images/workplace/emojis/heart_eyes_happy-3a38e97f249e215eea5dff0cda8ce21a.png";